import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

const companyFields = ['ice', 'if', 'patente', 'adresse', 'capital', 'cnss'];

const buildCompanyFormData = (payload = {}, { partial = false } = {}) => {
  const formData = new FormData();
  const data = payload.data || {};

  if (!partial || Object.prototype.hasOwnProperty.call(payload, 'name')) {
    formData.append('name', payload.name || '');
  }

  companyFields.forEach((field) => {
    if (!partial || Object.prototype.hasOwnProperty.call(data, field)) {
      formData.append(`data[${field}]`, data[field] || '');
    }
  });

  if (payload.logo instanceof File) {
    formData.append('logo', payload.logo);
  }

  return formData;
};

export const fetchCompanies = async () => {
  const res = await axios.get(`${API_URL}/companies`, header());
  return res.data;
};

export const fetchCompany = async (id) => {
  const res = await axios.get(`${API_URL}/companies/${id}`, header());
  return res.data;
};

export const createCompany = async (payload) => {
  const res = await axios.post(
    `${API_URL}/companies`,
    buildCompanyFormData(payload),
    header({ 'Content-Type': 'multipart/form-data' })
  );
  return res.data;
};

export const replaceCompany = async (id, payload) => {
  const res = await axios.put(
    `${API_URL}/companies/${id}`,
    buildCompanyFormData(payload),
    header({ 'Content-Type': 'multipart/form-data' })
  );
  return res.data;
};

export const updateCompany = async (id, payload) => {
  const res = await axios.patch(
    `${API_URL}/companies/${id}`,
    buildCompanyFormData(payload, { partial: true }),
    header({ 'Content-Type': 'multipart/form-data' })
  );
  return res.data;
};

export const deleteCompany = async (id) => {
  const res = await axios.delete(`${API_URL}/companies/${id}`, header());
  return res.data;
};

const CompanyService = {
  fetchCompanies,
  fetchCompany,
  createCompany,
  replaceCompany,
  updateCompany,
  deleteCompany,
};

export default CompanyService;
